import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators'
import { SharedService } from './shared.service';
import { Company } from '../entities/company';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};


@Injectable({
  providedIn: 'root'
})
export class CompanyService {


  constructor(private http: HttpClient, private sharedService: SharedService) { }


  getCompany(username: string): Observable<Company> {
    let company$ = this.http.get<Company>(this.sharedService.apiUrl('company') + username)
    return company$;
  }

  addCompany(company: any): Observable<any> {
    return this.http.post<any>(this.sharedService.apiUrl('company/add'), company, httpOptions).pipe(
      tap((company: any) => this.log(`added company w/ id=${company.id}`)),
      catchError(this.handleError<any>('add'))
    );
  }

  getCompanyList(): Observable<Company[]> {
    let company$ = this.http.get<Company[]>(this.sharedService.apiUrl('company'))
    return company$;
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  private log(message: string) {
    //this.messageService.add('TAS: ' + message);
  }
}
